import {getCityLink} from "../get_city_link";
import {getDistrictDisplayData} from "../get_district_display_data";

/** The city prices page filtered to a district, as the districts table links it: "/ceny/mieszkania/warszawa/?dist=mokotow". */
export const getDistrictLink = (citySlug: string, district: {slug: string; short_name?: string}): string =>
    `${getCityLink(citySlug)}?dist=${getDistrictDisplayData(district, citySlug).slug}`;
import {getCityLink} from "../get_city_link";
import {getDistrictDisplayData} from "../get_district_display_data";

/** The city prices page filtered to a district, as the districts table links it: "/ceny/mieszkania/warszawa/?dist=mokotow". */
export const getDistrictLink = (citySlug: string, district: {slug: string; short_name?: string}): string =>
    `${getCityLink(citySlug)}?dist=${getDistrictDisplayData(district, citySlug).slug}`;
